import { Stack } from '@fukuri-admins/ui/common/Stack';
import styles from './styles.module.scss';

/**
 * 送付先住所確認ダイアログの編集ビュー読み込み中 Presentation（Suspense fallback）
 *
 * 編集フォームが都道府県一覧を取得している間も同じダイアログ枠と見出しを表示し続ける。
 * 見出しの id は編集フォーム側と同じにして、読み込み中も aria-labelledby の参照先が DOM に存在するようにする。
 */
export const ShippingConfirmationDialogEditLoadingPresentation: React.FC = () => {
  return (
    <div className={styles.overlay}>
      <div
        className={styles.dialog}
        role='dialog'
        aria-modal='true'
        aria-labelledby='shipping-address-edit-form-title'
      >
        <Stack direction='column' gap={8}>
          <h2 className={styles.title} id='shipping-address-edit-form-title'>
            登録案内カードの発行内容の修正
          </h2>
          <p className={styles.loading}>読み込み中...</p>
        </Stack>
      </div>
    </div>
  );
};
